module.exports = __webpack_public_path__ + "img/pr-5.6a45764f.png";